// extracted by mini-css-extract-plugin
module.exports = {"placeholderContainer":"SelectYourRestaurantPlaceholder_placeholderContainer__8GL7N","selectRestaurantButton":"SelectYourRestaurantPlaceholder_selectRestaurantButton__7i4t8"};